import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { generatePath } from 'react-router-dom'
import { Breadcrumbs, Crumb } from '@carsys/ui'
import {
  supplierOrderChecklistPrintUrl,
  supplierOrderDetailUrl,
  supplierOrderPrintUrl,
  supplierOrderWholesalersUrl,
  supplierOrdersUrl
} from 'app/supplierOrders/routes'

export const SupplierOrdersBreadCrumbs: React.FC<React.ComponentProps<typeof Breadcrumbs>> = ({ ...props }) => {
  const { t } = useTranslation()
  const supplierOrderDetail = useSelector(state => state.supplierOrders.detail)
  const orderNumber = supplierOrderDetail?.header?.OrderNumber || ''
  const orderNumberText = () => {
    if (orderNumber) {
      return `${t('order.order_portal')} (${orderNumber})`
    }
    return t('order.order_portal')
  }

  // On UUID-based sub-routes (print/wholesalers/checklist) the matched URL contains the WorkorderUUID, not the
  // order number, so link the detail crumb to the parameterised order-number path. Fall back to the orders list
  // when the order number is unavailable to avoid routing to an unresolvable URL.
  const supplierOrderDetailPath = orderNumber ? generatePath(supplierOrderDetailUrl, { orderNumber }) : supplierOrdersUrl

  return (
    <Breadcrumbs {...props}>
      <Crumb data-testid='administration' key='administration' path={supplierOrdersUrl} text={t('global.sidebar_menu_administration')} />
      <Crumb data-testid='supplier-orders' key='supplier-orders' path={supplierOrdersUrl} text={t('global.sidebar_menu_supplier_orders')} />
      <Crumb
        data-testid='supplier-orders-detail'
        key='supplier-orders-detail'
        path={supplierOrderDetailUrl}
        to={supplierOrderDetailPath}
        text={orderNumberText()}
      />
      <Crumb data-testid='supplier-orders-print' key='supplier-orders-print' path={supplierOrderPrintUrl} text={t('global.print')} />
      <Crumb
        data-testid='supplier-orders-wholesalers'
        key='supplier-orders-wholesalers'
        path={supplierOrderWholesalersUrl}
        text={t('archive.wholesaler_orderdetails')}
      />
      <Crumb
        data-testid='supplier-orders-checklist-print'
        key='supplier-orders-checklist-print'
        path={supplierOrderChecklistPrintUrl}
        text={t('workorder.checklist_print')}
      />
    </Breadcrumbs>
  )
}

export default SupplierOrdersBreadCrumbs
